// Utility method to get a mapper for a specific entity.
// If mapper is not found a default one is returned.
import { defaultMapperKey, mappers, type MapperType } from "./mappers";

export const getMapperFor = (mapperName: string) => mappers[mapperName] || mappers[defaultMapperKey];

// This method allows to dynamically include new mappers
export const setMapperFor = (name: string, mapper: MapperType) => {
    mappers[name] = mapper;
};
